import { computed, ref } from 'vue';

export type TDemoClassTourDocumentationAction = 'learningProgress' | 'report';

interface IDemoClassTourController {
  start: () => Promise<void> | void;
}

const controller = ref<IDemoClassTourController | null>(null);
const isTourActive = ref(false);
const documentationAction = ref<TDemoClassTourDocumentationAction>('learningProgress');

export const resetDemoClassTour = (): void => {
  controller.value = null;
  isTourActive.value = false;
  documentationAction.value = 'learningProgress';
};

export function useDemoClassTour() {
  const register = (instance: IDemoClassTourController | null): void => {
    controller.value = instance;
  };

  const setTourActive = (active: boolean): void => {
    isTourActive.value = active;
  };

  const setDocumentationAction = (action: TDemoClassTourDocumentationAction): void => {
    documentationAction.value = action;
  };

  const startTour = async (): Promise<boolean> => {
    if (!controller.value) return false;
    await controller.value.start();
    return true;
  };

  return {
    register,
    setDocumentationAction,
    setTourActive,
    startTour,
    documentationAction: computed(() => documentationAction.value),
    isTourActive: computed(() => isTourActive.value),
  };
}
